import {
  ApolloErrorHandlerClient,
  ApolloErrorModalProvider,
  ErrorDetails,
  ErrorPayload,
  OperationName,
  useApolloErrorHandler,
  withApolloErrorHandler,
  withApolloErrorModal,
} from '@acorns/web-utils'

import AlertBadgePath from 'assets/icons/alert-badge.png'

export {
  ApolloErrorHandlerClient as IErrorModalProps,
  ApolloErrorHandlerClient as IWithErrorHandlerProps,
  ApolloErrorModalProvider as Provider,
  ErrorDetails as IErrorDetails,
  ErrorPayload as IErrorPayload,
  withApolloErrorHandler,
  withApolloErrorModal,
  useApolloErrorHandler,
  OperationName,
}

export const DEFAULT_ERROR_DETAILS = {
  body: 'It looks like something went wrong.',
  header: 'Oops!',
  image: AlertBadgePath,
} as ErrorDetails

// Helper HOF to only return an error config if a specific GraphQL error exists
export const mapConfigForGraphQLError =
  (
    errorName: string,
    errorConfig: ErrorDetails | ((props: any) => ErrorDetails | false),
  ) =>
  (props: any) =>
  ({ graphQLErrors = [] }) =>
    graphQLErrors.some(({ name }) => name === errorName)
      ? typeof errorConfig === 'function'
        ? errorConfig(props)
        : errorConfig
      : {}
